import { PaginatedList } from '@/data/hubspot/types/common';
import { InvoiceRequestBody, InvoicesData } from '@/data/hubspot/types/invoices';
import { useHubspotCustomerKy } from '@/data/hubspot/useHubSpotKy';
import { shouldMock } from '@/lib/utils';
import { useQuery } from '@tanstack/react-query';
import { closedInvoiceSampleData } from '../../sample/close-invoices';
import { openInvoicesSampleData } from '../../sample/open-invoices';

const DEFAULT_OPTIONS = {
  filter_type: 'OPEN',
  sort_by: 'DESC',
  sort_col: 'ISSUE_DATE',
  size: 10,
  page: 1,
};
export function useInvoices(options: Partial<InvoiceRequestBody>) {
  const ky = useHubspotCustomerKy();

  const pageBody = { ...DEFAULT_OPTIONS, ...options };
  console.log(options.filter_type);
  return useQuery({
    queryKey: ['invoices', pageBody],
    queryFn: async () => {
      if (shouldMock) {
        if (options.filter_type == 'CLOSED') {
          return closedInvoiceSampleData as unknown as PaginatedList<InvoicesData>;
        } else {
          return openInvoicesSampleData as unknown as PaginatedList<InvoicesData>;
        }
      }
      return ky
        .get(options.filter_type == 'CLOSED' ? 'closed-invoices' : 'open-invoices', {
          searchParams: pageBody,
        })
        .json<PaginatedList<InvoicesData>>();
    },
  });
}
